module.exports = __webpack_public_path__ + "img/zarahome_dennenprint.e5e82882.png";